import { useLayoutEffect } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import SplitType from "split-type";

gsap.registerPlugin(ScrollTrigger);

const useMasterGsapAnimations = (ref, options = {}) => {
  const {
    textSelector = ".gsap-text",
    triggerSelector = ".animate-section-trigger",
  } = options;

  useLayoutEffect(() => {
    let splits = [];

    const mm = gsap.matchMedia();

    mm.add("(min-width: 760px)", () => {
      const ctx = gsap.context(() => {

        /* SECTION ANIMATION */
        gsap.utils.toArray(".section-scroll-animation").forEach((section) => {
          if (!section) return;

          gsap.from(section, {
            y: 120,
            opacity: 0,
            duration: 3,
            ease: "power1.inOut",
            scrollTrigger: {
              trigger: section,
              start: "top 85%",
              end: "top center",
              scrub: 2,
            },
          });
        });

        /* TEXT SPLIT */
        gsap.utils.toArray(textSelector).forEach((el) => {
          if (!el) return;

          const triggerEl = el.closest(triggerSelector) || el;
          if (!triggerEl) return;

          const split = new SplitType(el, { types: "words, chars" });
          splits.push(split);

          gsap.timeline({
            scrollTrigger: {
              trigger: triggerEl,
              start: "top 75%",
              once: true,
            },
          }).from(split.words, {
            yPercent: 110,
            opacity: 0,
            duration: 0.6,
            stagger: 0.04,
          });
        });

      }, ref); // ✅ scoped to component

      return () => {
        ctx.revert();
        splits.forEach((s) => s.revert());
      };
    });

    // ✅ FULL cleanup (important)
    return () => {
      mm.revert();
    };

  }, [ref, textSelector, triggerSelector]);
};

export default useMasterGsapAnimations;